import { render, staticRenderFns } from "./BaseDataTableSearchInput.vue?vue&type=template&id=491a8d52&scoped=true"
import script from "./BaseDataTableSearchInput.vue?vue&type=script&lang=js"
export * from "./BaseDataTableSearchInput.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTableSearchInput.vue?vue&type=style&index=0&id=491a8d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a8d52",
  null
  
)

export default component.exports